.root {
    composes: dark from "../../styles/theming.module.css";
    padding-bottom: var(--spacer-16);
}

.grid {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.inner {
    grid-column: 1 / -1;
}

.logo {
    width: 100%;
    margin-top: var(--spacer-16);
}
